const getUpdatedAt = (rootState) => rootState.ws.view.updatedAt;

export default getUpdatedAt;
